module.exports = "/_next/static/images/video_id_7166760575450565930-bb295dd9395667033285d468836caec4.jpg";